<template>
  <Cfg>
    <slot>
      <Insured/>
    </slot>
  </Cfg>
</template>

<script>
import Cfg from '../configuration.vue'
import Insured from './insured.vue'

export default {
  name: 'insured-conf',
  components: {
    Cfg,
    Insured
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/insured/insured-conf.vue